// extracted by mini-css-extract-plugin
export default {"modal":"css_modal__Iqzuf","header":"css_header__mIef9","content":"css_content__mYj+q","text":"css_text__XO2X7","link":"css_link__ksZP2"};